/* @flow */
import MobileDetect from 'mobile-detect'
const md = new MobileDetect(window.navigator.userAgent)

export const isIOS = () => {
  return md.is('iOS')
}
